import React, { useState, useEffect } from "react";
import "./styles/layerfilter.css";

const IndexLayers = ({ colors, labels, translation }) => {
  const [indexBarColor, setIndexBarColor] = useState({});
  const [indexLabels, setIndexLabels] = useState([]);

  useEffect(() => {
    const indexColor = { background: "" };
    colors.length > 1
      ? (indexColor.background = `linear-gradient(${colors.join()})`)
      : (indexColor.background = colors.join());
    setIndexBarColor(indexColor);
    setIndexLabels(labels);
  }, [colors, labels]);

  return (
    <div className="index-container">
      <span className="gradient-bar" style={indexBarColor}></span>
      <span className="labels-container">
        {indexLabels.map((label) => (
          <i key={label}>{translation(`indexBar.${label}`)}</i>
        ))}
      </span>
    </div>
  );
};

export default IndexLayers;
